import React from "react";
//#region types
import { WintSuperkollAPIModel as ApiModels } from "wint-api-client/dist/types";
import { PersonSalaryStatusTagsProps } from "models/propTypes/salaryPropTypes";
//#endregion
//#region components
import { useSalaryService } from "serviceHooks";
import { Tags } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const PersonSalaryStatusTags: React.FC<PersonSalaryStatusTagsProps> = (props) => {
  const salaryService = useSalaryService();
  const { state } = props;

  const getLabelClass = (status: ApiModels.PersonSalaryViewState) => {
    switch (status) {
      case ApiModels.PersonSalaryViewState.ToApprove:
        return cssExports.yellowTag;
      case ApiModels.PersonSalaryViewState.InProcess:
        return cssExports.blueTag;
      case ApiModels.PersonSalaryViewState.InTheBooks:
        return cssExports.greenTag;
      case ApiModels.PersonSalaryViewState.HandledSoon:
      case ApiModels.PersonSalaryViewState.Cancelled:
        return cssExports.redTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[salaryService.getPersonSalaryStateText(state)]} className={getLabelClass(state)} />;
};

export default PersonSalaryStatusTags;
